<template> <!-- , maxHeight: '60vh' -->
  <Dialog v-model:visible="visible"
    :style="{ width: '700px' }"
    :modal="true"
    :contentStyle="{'overflow': 'visible'}"
    ref="dialog"
    @show="onShow"
    @hide="onHide"
    >
    <template #header>
      <h2>{{title}}</h2>
    </template>
    <div class="border-layout">
      <slot name="default" :onSelect="onSelect" />
    </div>
    <template #footer>
      <ButtonsApplyCancel @apply="onChoose" @cancel="$refs.dialog.close()" label-ok="Избор"/>
    </template>
  </Dialog>
</template>

<script>
export default {
  inheritAttrs: false,
  emits: {
    load: null,
    select: null
  },
  data() {
    return {
      visible: false,
      data: {}
    }
  },

  mounted() {
    if (this.$refs.content) {
      console.log(this.$refs.content)
    }
    //console.log(this.$slots)
  },

  props: {
    title: String,
    selected: Object
  },

  methods: {
    onShow() {
      this.data = {}
      this.$emit('load', this.data);
    },
    onHide() {
      this.data = {};
    },
    onChoose() {
      this.$emit('select', this.data);
      this.$refs.dialog.close();
    },
    onSelect(data) {
      console.log("Избран елемент за избор ", data)
      this.data = data;
    },
    open() {
      this.visible = true;
    }
  }
}
</script>

<style>
</style>
